import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

type SubmitResponsePath = paths['/v2/surveys/{id}/responses']['post'];

export type SubmitSurveyResponseBody =
  SubmitResponsePath['requestBody']['content']['application/json'];

type MyResponsesQuery = NonNullable<
  paths['/v2/surveys/responses/me']['get']['parameters']['query']
>;

/**
 * The subject-survey requests `fetchSurveysGateway` makes, kept apart from
 * `subjectSurveys.ts` for the same reason as `surveyRequests.ts`.
 *
 * Lists the caller's own responses, optionally scoped to a subject. The subject
 * filter is what the "has this expert already answered for this inquiry" gate
 * queries, so re-marking never re-opens an already-answered survey.
 */
export async function getMySurveyResponses(filter?: MyResponsesQuery) {
  const { data } = await fetchClient.GET('/v2/surveys/responses/me', {
    params: { query: filter ?? {} },
  });

  return data?.data ?? [];
}

/** Submits a response to a published survey, optionally linked to a subject. */
export async function submitSurveyResponse({
  surveyDefinitionId,
  answers,
  subject,
}: {
  surveyDefinitionId: string;
} & SubmitSurveyResponseBody) {
  const { data } = await fetchClient.POST('/v2/surveys/{id}/responses', {
    params: { path: { id: surveyDefinitionId } },
    body: { answers, subject },
  });

  return data?.data;
}
